import CryptoJS from 'crypto-js'
import { fromBase64UrlSafe } from '../base64/utils'

/**
 * @param encryptedUrlSafe   URL-safe Base64로 인코딩된 암호문
 * @param ivBase64           표준 Base64로 인코딩된 IV
 * @param encryptionKey      암호화 키 (각 프로젝트의 env에서 제공)
 */
export function decryptWithIv(encryptedUrlSafe: string, ivBase64: string, encryptionKey: string): string {
  try {
    // 1) URL-safe → 표준 Base64
    const base64Cipher = fromBase64UrlSafe(encryptedUrlSafe)

    // 2) WordArray로 파싱
    const ciphertextWA = CryptoJS.enc.Base64.parse(base64Cipher)
    const ivWA = CryptoJS.enc.Base64.parse(ivBase64)

    // 3) 키 준비
    const keyWA = CryptoJS.enc.Utf8.parse(encryptionKey)

    // 4) 복호화
    const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: ciphertextWA })
    const decryptedWA = CryptoJS.AES.decrypt(cipherParams, keyWA, {
      iv: ivWA,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })
    const decryptedText = decryptedWA.toString(CryptoJS.enc.Utf8)

    return decryptedText
  } catch (err) {
    console.error('❌ decryptWithIv 중 에러 발생:', err)
    return ''
  }
}
